import { API_URL } from "@/mainconfig"; // Impor instance API_URL dari mainconfig.js
import { getResponseMessage } from "@/utils/responseMapping";
import i18n from "@/plugins/LanguageComponent.js";

const state = {
    image: null, // Menyimpan data gambar
    error: null,
    errorKey: null,
    errorMessage: null,
    loading: false,
};

const getters = {
    isLoading: (state) => state.loading, // Mengecek status loading
    getError: (state) => state.error, // Mendapatkan error
    getImage: (state) => state.image, // Mendapatkan data gambar
};

const actions = {
    /**
     * Fetch image by ID
     * @param {Object} context - Vuex context
     * @param {Number} imageId - ID gambar
     */
    async fetchImage({ commit }, imageId) {
        commit("setLoading", true);
        try {
            const response = await API_URL.get(`/image/${imageId}`);
            commit("setImage", response.data); // Simpan data gambar ke state
            commit("setError", null); // Reset error jika berhasil
            return response;
        } catch (error) {
            const { status, data } = error.response || {};
            const errorKey = getResponseMessage(status, data?.code);
            commit("setError", errorKey || "errors.defaultError");
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    /**
     * Clear error
     */
    clearError({ commit }) {
        commit("clearError");
    },
};

const mutations = {
    /**
     * Set loading state
     * @param {Object} state - Vuex state
     * @param {Boolean} loading - Loading status
     */
    setLoading(state, loading) {
        state.loading = loading;
    },

    /**
     * Set image data
     * @param {Object} state - Vuex state
     * @param {Object} image - Image data
     */
    setImage(state, image) {
        state.image = image;
    },

    /**
     * Set error state
     * @param {Object} state - Vuex state
     * @param {String} errorKey - Error key
     */
    setError(state, errorKey) {
        state.errorKey = errorKey;
        state.errorMessage = errorKey ? i18n.global.t(errorKey) : null; // Terjemahkan errorKey
    },

    /**
     * Clear error state
     * @param {Object} state - Vuex state
     */
    clearError(state) {
        state.error = null;
        state.errorKey = null;
        state.errorMessage = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
